const generateTestId = (...labels) => `couples-search-${labels.join('-')}`;

export default generateTestId;
